import { AnexoDropzone } from 'app/components/Anexo';
import contasPagarApi from 'app/services/api/contasPagarApi';
import { useFormikContext } from 'formik';
import React from 'react';

const handleUpload = (handleChange) => {
  return (e) => {
    const files = e.target.value || [];

    const arquivos = [];

    files
      .filter((arquivo) => arquivo.id !== undefined)
      .forEach((element) => {
        arquivos.push(element);
      });

    files
      .filter((file) => !file.id)
      .forEach(async (file) => {
        const formData = new FormData();
        formData.append('arquivo', file);
        const resp = await contasPagarApi.upload(formData);
        arquivos.push({ ...resp.data, size: file.size });
        handleChange({ target: { id: 'anexos', value: arquivos } });
      });
  };
};
const ContasPagarAbaAnexo = () => {
  const formikContext = useFormikContext();

  const { values, handleChange } = formikContext;

  return (
    <AnexoDropzone
      id="anexos"
      onDropFile={handleUpload(handleChange)}
      onRemove={(file) => {
        const anexos = values.anexos.filter((a) => a.id !== file.id);
        handleChange({ target: { id: 'anexos', value: anexos } });
      }}
      files={values.anexos}
      showThumbnail
      linkDownload={'/api/v1/backend/conta-pagar/anexo/download'}
    />
  );
};

export default ContasPagarAbaAnexo;
